import React, { Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { withRouter } from "react-router-dom";

import ResizeDetector from "react-resize-detector";

import AppMain from "../../Layout/AppMain";
import LoginMain from "../../Layout/LoginMain";
import NoAccess from "../../Layout/NoAccess";
import env from "@beam-australia/react-env";
import AuthComponent from "../../components/AuthComponent"

// const OCF_CENTRAL_TITLE = window.ENV.OCF_CENTRAL_TITLE
const OCF_CENTRAL_TITLE = env('OCF_CENTRAL_TITLE');
class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // auth_checked: false,
      auth_checked_keycloak: false,
      // authenticated: false,
      keycloak_authenticated: false,
      closedSmallerSidebar: false,
      // permissions: [],
      permissions_keycloak: [],
      // updated: false,
      updated_keycloak: false,
      selected_instance_id: '',
      selected_agrupation: '',
      selected_council: ''
    };

    //Necessary to call this functions from outside
    // this.updateIsAuthenticated = this.updateIsAuthenticated.bind(this);
    this.updateIsAuthenticatedKeycloak = this.updateIsAuthenticatedKeycloak.bind(this);
    // this.updatePermissions = this.updatePermissions.bind(this);
    this.updatePermissionsKeycloak = this.updatePermissionsKeycloak.bind(this);

    // Instantiate the APICommunication class
    this.auth = new AuthComponent();
  }

  // /* 
  // ** @desc Update authentication data with the information coming from API component
  // ** @params response(object): The response from the API server
  // */
  // updateIsAuthenticated(response){
  //   if (typeof(response) != "undefined"){
  //     var resp = JSON.parse(response);
  //     // if (resp["value"]){
  //       this.setState({authenticated: resp["value"], auth_checked: true})
  //     // }
  //   }
  // }

  /* 
  ** @desc Update authentication data with the information coming from API component
  ** @params response(object): The response from the API server
  */
  updateIsAuthenticatedKeycloak(response){
    if (typeof(response) != "undefined"){
      var resp = JSON.parse(response);
      // if (resp["value"]){
       this.setState({keycloak_authenticated: resp["value"], auth_checked_keycloak: true})
      // }
    }
  }


  // updatePermissions(role,new_permissions){
  //   // Permissions received
  //   if (new_permissions != "User not authenticated"){
  //     this.setState({updated: true, permissions: new_permissions});
  //   }
    
  // }

  updatePermissionsKeycloak(role,new_permissions){
    // Permissions received
    if (new_permissions != "User not authenticated"){
      this.setState({updated_keycloak: true, permissions_keycloak: new_permissions});
    }
    
  }

  componentDidMount(){
    // this.auth.isAuthenticated(this.updateIsAuthenticated);
    this.auth.isAuthenticatedKeycloak(this.updateIsAuthenticatedKeycloak);
    // this.auth.getPermissions(this.updatePermissions);
    this.auth.getPermissionsKeycloak(this.updatePermissionsKeycloak);
  }


  // authenticate(){
  //   this.auth.authenticate(); 
  // }

  updateInstance(id){
    this.setState({selected_instance_id: id})
  }

  updateSelectedAgrupation(agrupation){
    this.setState({selected_agrupation: agrupation})
  }

  updateSelectedCouncil(council){
    this.setState({selected_council: council})
  }

  render() {
   
    document.title = OCF_CENTRAL_TITLE
    let {
      colorScheme,
      enableFixedHeader,
      enableFixedSidebar,
      enableFixedFooter,
      enableClosedSidebar,
      closedSmallerSidebar,
      enableMobileMenu,
      enablePageTabsAlt,
    } = this.props;
    // If checked authentication and the user is authenticated and permissions loaded show Elevate 
    if (this.state.keycloak_authenticated && this.state.auth_checked_keycloak && this.state.updated_keycloak){
      // var access = true;
      // this.state.permissions = {
      //   identities: {
      //     permit: "RW"
      //   }
      // }
      var access = false;

      if (this.state.keycloak_authenticated){
        var keys = Object.keys(this.state.permissions_keycloak)
        if (keys.length > 0){
          access = true;
        }
      }
     


      // for (let index = 0; index < this.state.permissions.length; index++) {
      //   var permission = this.state.permissions[index];
      //   if (permission != "None"){
      //     access = true;
      //   }
      // }

      // IF user has some permissions
      if (access){
        var permissions = []
        if (this.state.keycloak_authenticated){
          permissions = this.state.permissions_keycloak
        }
        return (
          <ResizeDetector
            handleWidth
            render={({ width }) => (
              <Fragment>
                <div
                  className={cx(
                    "app-container app-theme-" + colorScheme,
                    { "fixed-header": enableFixedHeader },
                    { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                    { "fixed-footer": enableFixedFooter },
                    { "closed-sidebar": enableClosedSidebar || width < 1250 },
                    {
                      "closed-sidebar-mobile": closedSmallerSidebar || width < 1250,
                    },
                    { "sidebar-mobile-open": enableMobileMenu },
                    { "body-tabs-shadow-btn": enablePageTabsAlt }
                  )}>
                    
                  <AppMain permissions={permissions} selected_instance_id={this.state.selected_instance_id} selected_agrupation={this.state.selected_agrupation} selected_council={this.state.selected_council} updateInstance={(id) => this.updateInstance(id)} updateSelectedAgrupation={(agrupation) => this.updateSelectedAgrupation(agrupation) } updateSelectedCouncil={(council) => this.updateSelectedCouncil(council)}/>
                </div>
              </Fragment>
            )}
          />
        );
      
      // ELSE IF user has no permissions
      } else {
        return (
          <ResizeDetector
            handleWidth
            render={({ width }) => (
              <Fragment>
                <div
                  className={cx(
                    "app-container app-theme-" + colorScheme,
                    { "fixed-header": enableFixedHeader },
                    { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                    { "fixed-footer": enableFixedFooter },
                    { "closed-sidebar": enableClosedSidebar || width < 1250 },
                    {
                      "closed-sidebar-mobile": closedSmallerSidebar || width < 1250,
                    },
                    { "sidebar-mobile-open": enableMobileMenu },
                    { "body-tabs-shadow-btn": enablePageTabsAlt }
                  )}>
                    
                  <NoAccess />
                </div>
              </Fragment>
            )}
          />
        );
      }
      

    // If checked authentication and the user is not authenticated show Elevate
    } else if (this.state.auth_checked_keycloak && !this.state.keycloak_authenticated){
      return (
        <ResizeDetector
          handleWidth
          render={({ width }) => (
            <Fragment>
              <div
                className={cx(
                  "app-container app-theme-" + colorScheme,
                  { "fixed-header": enableFixedHeader },
                  { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                  { "fixed-footer": enableFixedFooter },
                  { "closed-sidebar": enableClosedSidebar || width < 1250 },
                  {
                    "closed-sidebar-mobile": closedSmallerSidebar || width < 1250,
                  },
                  { "sidebar-mobile-open": enableMobileMenu },
                  { "body-tabs-shadow-btn": enablePageTabsAlt }
                )}>
                  
                <LoginMain />
              </div>
            </Fragment>
          )}
        />
      );
    
    // If authentication still not checked OR auth checked but permissions not loaded
    } else if (!this.state.auth_checked_keycloak || (this.state.keycloak_authenticated && this.state.auth_checked_keycloak && !this.state.updated_keycloak)){
      return (
        <ResizeDetector
          handleWidth
          render={({ width }) => (
            <Fragment>
              <div
                className={cx(
                  "app-container app-theme-" + colorScheme,
                  { "fixed-header": enableFixedHeader },
                  { "fixed-sidebar": enableFixedSidebar || width < 1250 },
                  { "fixed-footer": enableFixedFooter },
                  { "closed-sidebar": enableClosedSidebar || width < 1250 },
                  {
                    "closed-sidebar-mobile": closedSmallerSidebar || width < 1250,
                  },
                  { "sidebar-mobile-open": enableMobileMenu },
                  { "body-tabs-shadow-btn": enablePageTabsAlt }
                )}>
                  
                {/* <LoginMain /> */}
              </div>
            </Fragment>
          )}
        />
      );
    }


  }
}

const mapStateToProp = (state) => ({
  colorScheme: state.ThemeOptions.colorScheme,
  enableFixedHeader: state.ThemeOptions.enableFixedHeader,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  enableFixedFooter: state.ThemeOptions.enableFixedFooter,
  enableFixedSidebar: state.ThemeOptions.enableFixedSidebar,
  enableClosedSidebar: state.ThemeOptions.enableClosedSidebar,
  enablePageTabsAlt: state.ThemeOptions.enablePageTabsAlt,
});

export default withRouter(connect(mapStateToProp)(Main));
